module.exports = __webpack_public_path__ + "assets/img/logo-white.a6020496.png";